//react
import React, { useContext, useEffect, useState } from "react";

// react-icons
import { AiOutlineBarChart } from "react-icons/ai";

// mui
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Divider from "@mui/material/Divider";
import { Skeleton, Typography } from "@mui/material";

// context
import { DeviceContext } from "../../Context/deviceContext/deviceContext";

// apex chart
import ReactApexChart from "react-apexcharts";

// styles
import useStyles from "./graphStyles";

//axios
import axios, { Axios } from "axios";

//Casd-Header
const CardHeader = () => {
  const classes = useStyles();
  const { deviceData } = useContext(DeviceContext);
  return (
    <div>
      <Grid container>
        <Grid item container sx={{ padding: "10px" }}>
          <Grid
            item
            xs
            zeroMinWidth
            sx={{ display: "flex", justifyContent: "flex-start" }}
          >
            <Typography sx={{ fontSize: "15px", fontWeight: "bold" }}>
              Payload Received
            </Typography>
          </Grid>
          <Grid item>
            <Chip
              variant="outlined"
              sx={{
                fontSize: "13px",
                height: "20px",
                fontFamily: "Poppins, sans-serif",
                color: "#007fff",
              }}
              label="Last 7 days"
              size="small"
              color="primary"
            />
          </Grid>
        </Grid>
      </Grid>
      <Divider />
    </div>
  );
};

//Card-Content
const CardContent = (props) => {
  const classes = useStyles();
  const sum = props.alength;

  const SERIES = [
    {
      name: "Data points",
      data: props.datas,
    },
  ];

  const OPTIONS = {
    xaxis: {
      categories: props.date,
      labels: {
        style: {
          fontSize: "12px",
          fontFamily: "Poppins, sans-serif",
          fontWeight: "500",
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          fontSize: "12px",
          fontFamily: "Poppins, sans-serif",
          fontWeight: "500",
        },
        formatter: function (val) {
          return val.toFixed(0);
        },
      },
    },
    stroke: {
      width: 2,
      colors: ["#007fff"],
    },
    chart: {
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
      fontFamily: "Roboto",
      background: "white",
    },

    markers: {
      size: 4,
      shape: "circle",
      strokeColors: "#fff",
    },
  };

  return (
    <Box className={classes.chart}>
      {sum > 0 ? (
        <ReactApexChart
          className={classes.graphChart}
          options={OPTIONS}
          series={SERIES}
          type="line"
          height="210px"
          fontFamily="Poppins,sans-serif"
        />
      ) : (
        <>
          <Grid>
            <Grid item className={classes.noGraphData}>
              <AiOutlineBarChart
                style={{ fontSize: "14px", fontWeight: "1000", color: "black" }}
              />
              <Typography
                variant="h6"
                color="#6c757d"
                sx={{ fontSize: "14px" }}
              >
                Data unavailable
              </Typography>
            </Grid>
          </Grid>
        </>
      )}
    </Box>
  );
};

// DeviceGraph Component
const DeviceGraph = (props) => {
  // .env variables
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const bodyUrl = process.env.REACT_APP_GRAPH_MID_URL;

  const classes = useStyles();
  const [graphResponse, setGraphResponse] = useState([]);
  const [graphData, setGraphData] = useState([]);
  const [graphDate, setGraphDate] = useState([]);
  const [arrLength, setArrLength] = useState();
  const [isloading, setIsLoading] = useState(true);
  const [error, setError] = useState();

  useEffect(() => {
    getData2();
  }, []);

  const getData2 = () => {
    setIsLoading(true);
    axios
      .get(`${baseUrl}/${bodyUrl}${props.devEUI}`)
      .then((res) => {
        if (res.status === 200) {
          setIsLoading(false);
          setGraphResponse(res.data);
          setGraphData(res.data.total_data_received.reverse());
          setGraphDate(res.data.data_received_date.reverse());
          let dataMaxValue = Object.keys(res.data.total_data_received).length;
          setArrLength(dataMaxValue);
        }
      })
      .catch((err) => {
        setError(err);
        setIsLoading(false);
      });
  };

  return (
    <>
      <div>
        {isloading ? (
          <Skeleton
            animation="wave"
            sx={{
              mt: 5,
              borderRadius: 2,
              width: {
                xs: "300px",
                sm: "300px",
                md: "300px",
                lg: "300px",
                xl: "300px",
              },
              height: { xs: "440px", sm: "442px", md: "446px", lg: "441px" },
              marginTop: { xs: "-10px", sm: "-80px", md: "1px", lg: "1px" },
              padding: "10px",
            }}
          />
        ) : (
          <Card
            className={classes.root}
            sx={{
              mt: 2,
              borderRadius: 2,
              width: "300px",
              height: "17em",
              padding: "0px",
              marginTop: "",
            }}
          >
            <CardHeader />
            <CardContent
              alength={arrLength}
              datas={graphData}
              date={graphDate}
            />
          </Card>
        )}
      </div>
    </>
  );
};
export default DeviceGraph;
